// Updated Seat component with SB open size change
import React, { useEffect, useRef } from 'react';
import './seat.css';

const Seat = ({ 
  title,
  blinds,
  className,
  isActive,
  isDealer,
  bet,
  potSize,
  showPotWon,
  onPotWonChange,
  gameConfig
}) => {
  const renderCount = useRef(0);
  
  // For debugging only, remove in production if needed
  if (process.env.NODE_ENV === 'development') {
    console.log(`Seat ${title} render:`, {
      renderCount: renderCount.current++,
      title,
      showPotWon,
      isActive,
      bet
    });
  }

  // Simplify bet display logic to be consistent with how 3bet/call works
  let displayBet = bet;
  let shouldShowBet = true;
  
  // Set open size based on position for opener
  if (gameConfig && 
      title === gameConfig.openPosition && 
      (gameConfig.betType === 'OPEN')) {
    
    // Special case for SB open size - set to 3bb
    if (title === 'SB') {
      displayBet = 3;
    } else {
      // Standard 2.5bb open for all other positions
      displayBet = 2.5;
    }
  }
  
  // Set 3bet size based on position for 3bettor (unchanged)
  if (gameConfig && 
      title === gameConfig.threeBetPosition && 
      (gameConfig.betType === 'FACING_3BET_CALL' || gameConfig.betType === 'FACING_3BET_4BET')) {
    
    // Define standard position hierarchy for determining in-position/out-of-position
    const positionValues = {
      'BTN': 6, 'CO': 5, 'HJ': 4, 'LJ': 3, 'SB': 2, 'BB': 1
    };
    
    // Determine if 3bettor is in position relative to opener
    const is3BettorInPosition = positionValues[gameConfig.threeBetPosition] > positionValues[gameConfig.openPosition];
    
    // Set correct 3bet size based on position
    displayBet = is3BettorInPosition ? 7.5 : 10;
  }
  
  // Set open size for opener in 3bet/4bet scenarios (unchanged)
  if (gameConfig && 
      title === gameConfig.openPosition && 
      (gameConfig.betType === 'FACING_3BET_CALL' || gameConfig.betType === 'FACING_3BET_4BET')) {
    
    // Special case for SB open size in 3bet/4bet scenarios
    if (title === 'SB') {
      displayBet = 3;
    } else {
      displayBet = 2.5;
    }
  }

  useEffect(() => {
    if (onPotWonChange) {
      onPotWonChange(showPotWon);
    }
  }, [showPotWon, onPotWonChange]);

  return (
    <div className={`seat ${className} ${isActive ? 'seat-on' : ''}`}>
      <div className="seat-content">
        <div className="title">{title}</div>
        <div className="big-blinds">{blinds}</div>
      </div>
      
      {isDealer && (
        <div className="dealer-button">
          <img 
            src="/svgs/dealer.svg" 
            alt="Dealer" 
            width="24" 
            height="24" 
          />
        </div>
      )}
      
      {isActive && (
        <div className="cards-container">
          <div className="card card-1"></div>
          <div className="card card-2"></div>
        </div>
      )}
      
      {/* Simplified condition: always show bet if displayBet > 0 */}
      {displayBet > 0 && (
        <div className="preflop-bet-container">
          <div className="bet-stack">
            <div className="bet-text">{displayBet}<span className="bet-unit">bb</span></div>
            <div className="bet-image">
              <img 
                src="/svgs/chip.svg"
                alt="Betting chip"
                className="bet-chip"
                width="24" 
                height="24"
              />
            </div>
          </div>
        </div>
      )}

      {showPotWon && (
        <div className="pot-won-container">
          <img 
            src="/svgs/pot-won.svg"
            alt="Pot Won Icon"
            className="pot-won-icon"
            width="57" 
            height="42"
          />
          <span className="pot-won-amount">
            <span className="pot-won-value">{potSize}</span>
            <span className="pot-won-unit">bb</span>
          </span>
        </div>
      )}
    </div>
  );
};

export default React.memo(Seat);